import { useEffect, useState } from 'react'

import { createHealthInstance } from '@/helpers/api/base'
import { setLocalStorageItem } from '@/helpers/localStorage'

const INTERVAL = import.meta.env.VITE_API_HEALTH_CHECK_INTERVAL || 15000 // Default interval is 15 sec

export const useOffline = () => {
    const [isOffline, setIsOffline] = useState(false)

    const health = async () => {
        try {
            await createHealthInstance({
                url: '/health',
                method: 'GET',
            })
            setIsOffline(false)
        } catch (error) {
            setIsOffline(true)
        }
    }

    useEffect(() => {
        // Initial check
        health()

        const intervalId = setInterval(health, INTERVAL)

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    useEffect(() => {
        setLocalStorageItem('isOffline', isOffline.toString())
    }, [isOffline])

    return isOffline
}
